import { getInitState } from 'app/utils/async-middleware';
import { actionTypes } from 'app/common/actions/kpi-metadata';

const initState = getInitState();

export default (state = { ...initState }, action: any) => {
  switch (action.type) {
    case actionTypes.fetchKpiMetadata: {
      const { type, ...restAction } = action;

      return {
        ...state,
        ...restAction,
      };
    }

    default:
      return state;
  }
};
